<template id="drilldown-report-page">
  <section>
    <div class="row">
      <div class="card-section">
        <div class="card" :class="this.$store.state.bannerStatus ? 'banner-true' : 'banner-false'">
<!--          <div class="card-header d-flex flex-column" style="padding: 5px 10px;">-->

<!--            &lt;!&ndash; 🔹 Top row &ndash;&gt;-->
<!--&lt;!&ndash;            <div class="d-flex justify-content-between align-items-center w-100">&ndash;&gt;-->
<!--&lt;!&ndash;              <strong>&ndash;&gt;-->
<!--&lt;!&ndash;                <i v-if="$store.state.deviceType==='Mobile'"&ndash;&gt;-->
<!--&lt;!&ndash;                   :class="repTitle? 'fa fa-info-circle custom-icon' : 'fa fa-info-circle'"&ndash;&gt;-->
<!--&lt;!&ndash;                   ref="tooltipIcon"&ndash;&gt;-->
<!--&lt;!&ndash;                   v-b-tooltip.hover.right.html="{ title: repTitle, customClass: 'my-custom-tooltip', autoHide: false }"&ndash;&gt;-->
<!--&lt;!&ndash;                   @mouseenter="showTooltip"&ndash;&gt;-->
<!--&lt;!&ndash;                   @mouseleave="hideTooltip">&ndash;&gt;-->
<!--&lt;!&ndash;                </i>&ndash;&gt;-->
<!--&lt;!&ndash;                <i  v-if="$store.state.deviceType !== 'Mobile'"&ndash;&gt;-->
<!--&lt;!&ndash;                    :class="screenTitleInfo? 'fa fa-info-circle custom-icon' : 'fa fa-info-circle'"&ndash;&gt;-->
<!--&lt;!&ndash;                   ref="tooltipIcon"&ndash;&gt;-->
<!--&lt;!&ndash;                   v-b-tooltip.hover.right.html="{ title: screenTitleInfo, customClass: 'my-custom-tooltip', autoHide: false }"&ndash;&gt;-->
<!--&lt;!&ndash;                   @mouseenter="showTooltip"&ndash;&gt;-->
<!--&lt;!&ndash;                   @mouseleave="hideTooltip">&ndash;&gt;-->
<!--&lt;!&ndash;                </i>&ndash;&gt;-->
<!--&lt;!&ndash;                <span v-if="$store.state.deviceType !== 'Mobile'" class="ml-1">{{ repTitle }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;              </strong>&ndash;&gt;-->

<!--&lt;!&ndash;              <div v-if="checkboxFlag[1] && $store.state.deviceType==='Mobile'">&ndash;&gt;-->
<!--&lt;!&ndash;      <span @click="assignBox(selectedRows)">&ndash;&gt;-->
<!--&lt;!&ndash;        <i class="fa fa-user-cog text-info" style="padding:5px"></i>&ndash;&gt;-->
<!--&lt;!&ndash;      </span>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->

<!--&lt;!&ndash;              <div class="d-flex align-items-center">&ndash;&gt;-->
<!--&lt;!&ndash;                 <span style="color:steelblue" v-if="checkboxFlag[1] && selectedRows.length>0 && $store.state.deviceType!=='Mobile'">&ndash;&gt;-->
<!--&lt;!&ndash;                {{&ndash;&gt;-->
<!--&lt;!&ndash;                     selectedRows.length&ndash;&gt;-->
<!--&lt;!&ndash;                   }} selected out of {{&ndash;&gt;-->
<!--&lt;!&ndash;                     selectableCount !== null ? selectableCount + ' editable (' + filteredItems.length + ' total)' : filteredItems.length + ' total'&ndash;&gt;-->
<!--&lt;!&ndash;                   }}&ndash;&gt;-->
<!--&lt;!&ndash;              </span>&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="flex-grow-0" style="min-width: 200px; max-width: 300px; margin-left: 10px;">&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="input-group">&ndash;&gt;-->
<!--&lt;!&ndash;                    <input type="text"&ndash;&gt;-->
<!--&lt;!&ndash;                           v-model="filterValue"&ndash;&gt;-->
<!--&lt;!&ndash;                           placeholder="Search on Display..."&ndash;&gt;-->
<!--&lt;!&ndash;                           class="form-control form-control-sm">&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                <span v-for="(ai,index) in currentRepActionIconsData" :key="index">&ndash;&gt;-->
<!--&lt;!&ndash;        <download-csv v-if="ai.actionIconsName=== 'download'" class="btn btn-default" :data="cleanedDownload"&ndash;&gt;-->
<!--&lt;!&ndash;                      :name="momentAll" v-on:click="handleActionIconFunctionCall(ai.functionName,index)">&ndash;&gt;-->
<!--&lt;!&ndash;          <i v-bind:id="ai.iconId" v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"&ndash;&gt;-->
<!--&lt;!&ndash;             :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"&ndash;&gt;-->
<!--&lt;!&ndash;             style="font-size:15px; float: right; margin-top: -3px; ">&ndash;&gt;-->
<!--&lt;!&ndash;          </i>&ndash;&gt;-->
<!--&lt;!&ndash;        </download-csv>&ndash;&gt;-->

<!--&lt;!&ndash;        <span v-on:click="handleActionIconFunctionCall(ai.functionName,index)">&ndash;&gt;-->
<!--&lt;!&ndash;          <i v-if="ai.actionIconsName!== 'download'" v-bind:id="ai.iconId"&ndash;&gt;-->
<!--&lt;!&ndash;             v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"&ndash;&gt;-->
<!--&lt;!&ndash;             :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"&ndash;&gt;-->
<!--&lt;!&ndash;             style="font-size:15px; padding-left:10px;">&ndash;&gt;-->
<!--&lt;!&ndash;          </i>&ndash;&gt;-->
<!--&lt;!&ndash;        </span>&ndash;&gt;-->
<!--&lt;!&ndash;      </span>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->

<!--            &lt;!&ndash; 🔹 Bottom row (Mobile selection text) &ndash;&gt;-->
<!--            <div v-if="checkboxFlag[1] && selectedRows.length>0 && $store.state.deviceType==='Mobile'" class="mt-1">-->
<!--    <span style="color:steelblue">-->
<!--      {{ selectedRows.length }} selected out of {{-->
<!--        selectableCount !== null ? selectableCount + ' editable (' + filteredItems.length + ' total)' : filteredItems.length + ' total'-->
<!--      }}-->
<!--    </span>-->
<!--            </div>-->

<!--          </div>-->

          <div class="card-body">
            <b-overlay :show="spinner">
              <div class="table-responsive" :aria-hidden="spinner ? 'true' : null">
                <div v-if="isMultiFieldUpdate && checkboxFlag[1]" class="d-flex align-items-center my-2 card-body-header">
                  <span @click="assignBox(selectedRows)" style="cursor:pointer;" title="Update selected rows">
                    <i class="fa fa-user-cog text-info" style="padding:5px"></i>
                  </span>
                  <span v-if="selectedRows.length>0" style="color:steelblue; margin-left:8px;">
                    {{ selectedRows.length }} selected
                  </span>
                </div>
                <div class="grid-container" :style="{ height: gridContainerHeight }">
                  <table v-show="showTable" class="table table-bordered table-hover">
                    <thead class="thead-dark" align="center">
                    <tr>
                      <th class='grid-item--header-one' v-if="checkboxFlag[1]">
                        <input type="checkbox" v-model="isAllSelected" @click="selectAll">
                      </th>
                      <th v-else-if="!isMultiFieldUpdate">Action</th>
                      <th v-if="drilldownlevels.length>1"></th>
                      <th :class="index==0?'':''" v-for="(col,index) in headerColumns[1]" v-bind:key="col">
                        {{ col }}
                        <a href="#" @click="sortBy(Rcolumns[index])">
                          <i class="fa"
                             v-bind:class="Rcolumns[index]===sortKey ? (sortOrder === 'asc' ?  'fa-sort-amount-down-alt' : 'fa-sort-amount-up-alt') : 'fa-sort' "
                             v-bind:style="[Rcolumns[index]===sortKey ? {'color':'Gold'} : {'color':'White'}]">
                          </i>
                        </a>
                      </th>
                      <th>Assign</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(rowd,idx) of filteredItems ">
                      <tr v-bind:style="whatL1===rowd['rd1l1_name']?'background-color:#63BFF8':''"
                          v-bind:key="idx" :class="getClass(getRowColorValue(rowd, 'level1'))">
                        <td class='grid-col--fixed-left' v-if="checkboxFlag[1]">
                          <input type="checkbox" v-model="selectedRows" :value="rowd.rd1l1_name"
                                 :disabled="!isRowEditable(rowd)"
                                 :title="!isRowEditable(rowd) ? 'Selection not allowed' : ''"
                                 :class="{ 'disabled-checkbox': !isRowEditable(rowd) }"
                          >
                        </td>
                        <td v-else-if="!isMultiFieldUpdate">
                          <span
                              @click="assignBox([rowd.rd1l1_name || rowd.dim1_name])"
                              style="cursor:pointer;"
                              title="Assign"
                          >
                            <i class="fa fa-user-cog text-info"></i>
                          </span>
                        </td>
                        <td v-if="drilldownlevels.length>1">
                          <span @click="toggleL1(rowd)">
                            <span class="offset-md-0" style="cursor: pointer">
                              {{ isExpandedL1(rowd) ? '-' : '+' }}
                            </span>
                          </span>
                        </td>
                        <td :class="index==0?'': col.startsWith('rm')?'text-right':''"
                            v-for="(col,index) in Rcolumns"
                            v-bind:key="col">
                          <!-- Check if the cell value is a URL/hyperlink -->
                          <span v-if="col.toLowerCase().startsWith('hyperlink') && rowd[col]">
                            <a :href="rowd[col]" target="_blank" class="text-primary text-decoration-underline"  v-html="hyperlinkConfig">
                            </a>
                          </span>
                          <span v-else>
                            {{ rowd[col] }}
                          </span>
                        </td>
                        <td>
                          <span v-if="rowd.assign==null">- NA -</span>
                          <span v-if="rowd.assign!=null">{{ rowd.assign }}</span>
                        </td>
                      </tr>
                      <tr v-if="isExpandedL1(rowd) && firstDrilldownData.length > 0 && headerLvl2Display==='true'"
                          class="table-info" v-bind:key="`c-${idx}`">
                        <th></th>
                        <template v-for="col in headerColumns[2]">
                          <th v-bind:key="col"><span class="offset-md-1"> {{ col }} </span></th>
                        </template>
                        <!--                          <th>Action</th>-->
                        <th v-if="hasLevelActions('level2')">Action</th>
                        <th>Assign</th>
                      </tr>
                      <template v-for="(first,idx) of firstDrilldownData">
                        <tr v-bind:key="`first-${idx}`"
                            v-if="isExpandedL1(rowd)" style="background-color: #8FD1FA">
                          <td>
                            <a @click="toggleL2(rowd, first)">
                              <span class="offset-md-1" style="cursor: pointer">
                                {{ isExpandedL2(first) ? 'v' : '>' }} <!-- toggle symbol -->
                              </span>
                            </a>
                          </td>
                          <td :class="{'text-right' : col2.startsWith('rm')}" v-for="col2 in R2columns"
                              v-bind:key="col2">
                            <span class="offset-md-1">
                              {{ col2 === 'n' ? headerColumns[2][1] : first[col2] }}
                            </span>
                          </td>
                          <!--                            <td>
                                                        &lt;!&ndash;                          <span @click="commentBox(first['rd1_id'])">
                                                                                          <i class="fa fa-lg fa-comments text-primary"></i>
                                                                                      </span>
                                                                                <span @click="tagBox('Retailer Drilldown', 'drilldown_report')">
                                                                                          <i class="fa fa-tags text-primary" style="padding:5px"></i>
                                                                                      </span>
                                                                                <span @click="assignBox('retailer_view', p.retailer_id)">
                                                                                              <i class="fa fa-user-cog text-info"></i>
                                                                                          </span>
                                                                                <span @click="accept(rowd['rd1l1_name'])" title="Accept">
                                                                                          <i class="fas fa-thumbs-up"></i>
                                                                                        </span>
                                                                                <span @click="reject(rowd['rd1l1_name'])" title="Reject">
                                                                                          <i class="fas fa-thumbs-down"></i>
                                                                                        </span>&ndash;&gt;
                                                        <span v-for="(ai,index) in currentMenuActionIconsData[2]" :key="index">
                                                          <span v-on:click="handleActionIconFunctionCall(ai.functionName,index,rowd['rd1l1_name'])">
                                                            <i v-bind:id="ai.iconId"
                                                              v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
                                                              :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
                                                              style="font-size:15px; padding-left:10px; color:skyblue">
                                                            </i>
                                                          </span>
                                                        </span>
                                                        &lt;!&ndash;                                  <a :href="downloadFile(rowd['rd1l2_name'])" target="_blank">&ndash;&gt;
                                                        &lt;!&ndash;                                    <i class="fa fa-download text-info"></i>&ndash;&gt;
                                                        &lt;!&ndash;                                  </a></td>&ndash;&gt;
                                                      </td>-->
                          <td v-if="hasLevelActions('level2')">
                            <span
                                v-for="(action, actionIndex) in getLevelActions('level2')"
                                :key="`l2-action-${actionIndex}`"
                                @click="openActionDialog(first, 'level2', action)"
                                class="mr-2"
                                style="cursor:pointer;"
                                :title="action.name"
                            >
                              <i :class="getActionIconClass(action)"></i>
                            </span>
                          </td>
                          <td v-b-tooltip.hover title="Assign">
                            <span data-ng-if="rowd.assign==null">- NA -</span>
                            <span data-ng-if="rowd.assign!=null">{{ rowd.assign }}</span>
                          </td>
                        </tr>
                        <tr v v-if="isExpandedL1(rowd) && isExpandedL2(first) && headerLvl3Display==='true'"
                            class="table-primary"
                            v-bind:key="`second-${idx}`">
                          <th></th>

                          <template v-for="col in headerColumns[3]">
                            <th v-bind:key="col"><span class="offset-md-2"> {{ col }} </span></th>
                          </template>
                          <!--                            <th>Action</th>-->
                          <th v-if="hasLevelActions('level3')">Action</th>
                          <th>Assign</th>
                        </tr>
                        <template v-for="(snd,idx) of secondDrilldownData">
                          <tr v-bind:key="`second2-${idx}`" style="background-color: #E7F5FE"
                              v-if="whatL1 === (rowd.rd1l1_id != null ? rowd.rd1l1_id : rowd.rd1l1_name) && whatL2 === (first.rd1l2_name ? first.rd1l2_name:false) && secondDrilldownData.length>0">


                            <td><span class="offset-md-2">&#8680;</span></td>
                            <td :class="{'text-right' : col3.startsWith('rm')}" v-for="col3 in R3columns"
                                v-bind:key="col3">
                              <span class="offset-md-1">
                                {{ col3 === 'n' ? headerColumns[3][1] : snd[col3] }}
                              </span>
                            </td>

                            <!--                              <td>
                                                          &lt;!&ndash;
                                                                                      <span @click="commentBox(snd['rd1_id'])">
                                                                                                  <i class="fa fa-lg fa-comments text-primary"></i>
                                                                                              </span>
                                                                                      <span @click="tagBox('Retailer Drilldown', 'drilldown_report')">
                                                                                                  <i class="fa fa-tags text-primary" style="padding:5px"></i>
                                                                                              </span>
                                                                                      <span @click="assignBox('retailer_view', p.retailer_id)">
                                                                                                      <i class="fa fa-user-cog text-info" style="padding:5px"></i>
                                                                                                  </span>
                                                          &ndash;&gt;
                                                            <span v-for="(ai,index) in currentMenuActionIconsData[3]" :key="index">
                                                              <span v-on:click="handleActionIconFunctionCall(ai.functionName,index)">
                                                                <i v-bind:id="ai.iconId"
                                                                   v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
                                                                   :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
                                                                    style="font-size:15px; padding-left:10px; color:skyblue">
                                                                </i>
                                                              </span>
                                                            </span>

                                                            &lt;!&ndash;                                      <a :href="downloadFile(rowd['rd1l2_name'])" target="_blank">&ndash;&gt;
                                                            &lt;!&ndash;                                        <i class="fa fa-download text-info"></i>&ndash;&gt;
                                                            &lt;!&ndash;                                      </a>&ndash;&gt;
                                                          </td>-->
                            <td v-if="hasLevelActions('level3')">
                              <span
                                  v-for="(action, actionIndex) in getLevelActions('level3')"
                                  :key="`l3-action-${actionIndex}`"
                                  @click="openActionDialog(snd, 'level3', action)"
                                  class="mr-2"
                                  style="cursor:pointer;"
                                  :title="action.name"
                              >
                                <i :class="getActionIconClass(action)"></i>
                              </span>
                            </td>
                            <td>
                              <span data-ng-if="rowd.assign==null">- NA -</span>
                              <span data-ng-if="rowd.assign!=null">{{ rowd.assign }}</span>
                            </td>
                          </tr>
                        </template>
                      </template>
                    </template>
                    <!-- <tr v-for ="header in headerColumns" v-bind:key="header" >
                    <td v-for="col in header" v-bind:key="col"> {{col }}</td>
                    <td> {{header}}</td></tr>-->
                    </tbody>
                  </table>
                </div>
                <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
                  <b-form-group label="Comment">
                    <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
                  </b-form-group>
                </b-modal>

                <b-modal ref="tag-box" @ok="postTagging()" :title="tagTitle">
                  <b-form-group label="Tagging">
                    <!--
                                      <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="OnTrack" v-model="picked"> OnTrack
                                      <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="RedFlag" v-model="picked"> RedFlag
                                      <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="Validate" v-model="picked"> Validate
                    -->
                    <!--                  <span v-if="iconsConfig.tag_type=='radio'">
                                      <span  v-for="v in iconsConfig.tagList" :key="v">
                                      <input  type="radio" name="inlineRadioOptions" id="inlineRadio1" :value="v.tag_list" v-model="picked"> {{v.tag_list}}
                                      </span>
                                      </span>

                                      <span v-if="iconsConfig.tag_type=='checkbox'">
                                      <span  v-for="v in iconsConfig.tagList" :key="v">
                                      <input  type="checkbox" name="inlineCheckbox" :value="v" v-model="v.value"> {{v.tag_list}}
                                      </span>
                                      </span>-->

                    <v-select v-if="iconsConfig.tag_type=='dropdown'" multiple v-model="selected"
                              :options="this.iconsConfig['tagList'].map(k=>k['tag_list'])"
                              :close-on-select="false"></v-select>

                  </b-form-group>

                  <b-form-group label="Comment">
                    <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
                  </b-form-group>
                </b-modal>

                <b-modal v-if="currentMenuActionIconsData.length>0" ref="assign-box" @ok="postAssign()"
                         :title="tagTitle">

                  <b-form-group v-for="(icon,index) in iconsConfig" :key="index"
                                :label="icon.is_group_action=='yes'?'':icon.name" label-class="font-weight-bold">
<span v-if="icon.is_group_action=='yes'">
                  <b-form-group v-for="(gicon,index) in actionLevels" :key="index"
                                :label="filteredConfig[0][gicon+'_field_name']" label-class="font-weight-bold">

                    <span v-if="filteredConfig[0][gicon+'_input_type']==='radio'">
<!--                      {{actionOptions[gicon+'_value']}}-->
                  <span v-for="(v,index) in actionOptions[gicon+'_value']" :key="index">
                  <input @input="appendCurLevel(gicon)" type="radio" :name="gicon+'radioOptions'" :id="gicon+'radio'"
                         :value="v" v-model="selectConfigVal[gicon+'_value']"> {{ v }}
                  </span>
                  </span>

                  <span v-if="filteredConfig[0][gicon+'_input_type']==='checkbox'">
                  <span v-for="(v,index) in actionOptions[gicon+'_value']" :key="index">
                  <input @input="appendCurLevel(gicon,'checkbox',$event)" type="checkbox" :id="index" :value="v"
                         v-model="checkboxSelected"> {{ v }}
                  </span>
                    <!--                    Selected : {{checkboxSelected}}-->
                    <!--                    Selected : {{selectConfigVal[gicon+'_value']}}-->
                  </span>
                  <span>

                  <v-select @input="appendCurLevel(gicon)" v-if="filteredConfig[0][gicon+'_input_type']==='dropdown'"
                            v-model="selectConfigVal[gicon+'_value']"
                            :options="actionOptions[gicon+'_value']"
                            :close-on-select="true"></v-select>
                  </span>
                  <input v-if="filteredConfig[0][gicon+'_input_type']==='datepicker'" type="date" name="inlineDatefield"
                         v-model="selectConfigVal[gicon+'_value']">

                    <input v-if="filteredConfig[0][gicon+'_input_type']==='number_input'" type="number"
                           name="numericField" id="numeric" v-model="selectConfigVal[gicon+'_value']">
                    <input v-if="filteredConfig[0][gicon+'_input_type']==='text_input'" type="text" name="textField"
                           id="text" v-model="selectConfigVal[gicon+'_value']">


                  </b-form-group>
</span>
                    <span v-else>

                     <input v-if="icon.action_type==='number_input'" type="number" name="numericField" id="numeric"
                            v-model="icon.value">
                    <input v-if="icon.action_type==='text_input'" type="text" name="textField" id="text"
                           v-model="icon.value">

                    <textarea v-if="icon.action_type==='textarea'" rows="3" cols="40" v-model="icon.value"
                              placeholder="Write a comment..."></textarea>

                  <span v-if="icon.action_type==='radio'">
                  <span v-for="(v,index) in icon.tagList" :key="index">
                  <input type="radio" name="inlineRadioOptions" id="inlineRadio1" :value="v.tag_list"
                         v-model="icon.value"> {{ v.tag_list }}
                  </span>
                  </span>

                  <span v-if="icon.action_type==='checkbox'">
                  <span v-for="(v,index) in icon.tagList" :key="index">
                  <input type="checkbox" name="inlineCheckbox" :value="v" v-model="v.value"> {{ v.tag_list }}
                  </span>
                  </span>
                  <span>
                  <v-select v-if="icon.action_type==='dropdown'" v-model="icon.value"
                            :options="getUniqueTagOptions(icon)"
                            :close-on-select="true"></v-select>
                  </span>
                  <input v-if="icon.action_type==='datepicker'" type="date" name="inlineCheckbox" v-model="icon.value">
                  </span>


                    <!--                  <select v-if="icon.action_type=='" v-model="assigned" >
                                        <option v-for="(v,index) in iconsConfig.tagList" :key="index" :value="v.tag_list"> {{v.tag_list}}</option>
                                      </select>-->

                  </b-form-group>
                  <button @click="resetActionOptions" name="Reset">Reset</button>
                  <!--                  <b-form-group v-if="currentMenuActionIconsData[1].filter(f=>f.functionName==='tagBox' ).length>0" label="Tagging">
                                      &lt;!&ndash;
                                                        <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="OnTrack" v-model="picked"> OnTrack
                                                        <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="RedFlag" v-model="picked"> RedFlag
                                                        <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="Validate" v-model="picked"> Validate
                                      &ndash;&gt;
                                      <span v-if="iconsConfig.tag_type=='radio'">
                                    <span  v-for="(v,index) in iconsConfig.tagList" :key="index">
                                    <input  type="radio" name="inlineRadioOptions" id="inlineRadio1" :value="v.tag_list" v-model="picked"> {{v.tag_list}}
                                    </span>
                                    </span>

                                      <span v-if="iconsConfig.tag_type=='checkbox'">
                                    <span  v-for="(v,index) in iconsConfig.tagList" :key="index">
                                    <input  type="checkbox" name="inlineCheckbox" :value="v" v-model="v.value"> {{v.tag_list}}
                                    </span>
                                    </span>

                                      <v-select v-if="iconsConfig.tag_type=='dropdown'" multiple v-model="selected"
                                                :options="this.iconsConfig['tagList'].map(k=>k['tag_list'])"
                                                :close-on-select="false"></v-select>
                                    </b-form-group>
                                  <b-form-group v-if="currentMenuActionIconsData[1].filter(f=>f.functionName==='assignBox' ).length>0" label="Assign">
                                      <select v-model="assigned" >
                                      &lt;!&ndash;<option value="Andy">Andy</option>
                                      <option value="Sarah">Sarah</option>
                                      <option value="Roger">Roger</option>
                                      <option value="Mark">Mark</option>
                                      <option value="Kane">Kane</option> &ndash;&gt;
                                      <option v-for="ov in userData" :key="ov.userName" :value="ov.firstName"> {{ov.firstName}}</option>
                                    </select>
                                  </b-form-group>
                                  <b-form-group v-if="currentMenuActionIconsData[1].filter(f=>f.functionName==='commentBox' ).length>0" label="Comment">
                                    <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
                                  </b-form-group>-->
                </b-modal>
                <b-modal ref="accept-box" @ok="loadReportlevel1()" title="Accept Dialog">
                  <b-form-group label="Accept">
                    <p> Merge the Customer</p>
                  </b-form-group>
                </b-modal>
                <b-modal ref="reject-box" @ok="loadReportlevel1()" title="Reject Dialog">
                  <b-form-group label="Reject">
                    <p> Reject the matching Customer and keep it separate</p>
                  </b-form-group>
                </b-modal>
                <b-modal ref="error-box" title="Oops! Something went wrong!">
                  <p>Please check your row selection/checkbox.<br/>
                    Min one row should be selected. Max 500 can be updated at once.</p>
                </b-modal>

              </div>
            </b-overlay>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import _ from 'lodash'
import moment from "moment";
import {apiAbort} from "@/common/apiAbort";

export default {
  name: 'drilldown-report-page',
  props: {
    id: {
      type: String,
      default: ''
    },
    viz1: {
      type: Object,
      default: () => ({})
    },
    filters: Object,
  },
  components: {},
  data: function () {
    return {
      title:'',
      spinner: false,
      file: '',
      output: [],
      currentMenuActionIconsData: [],
      currentRepActionIconsData: {},
      levelicons: [],
      iconOnChangeFlag: [],
      repTitle: '',
      keys: [],
      customerData: [],
      submenuParam1: null,
      firstDrilldownData: [],
      secondDrilldownData: [],
      cleanedDownload: [],
      drilldowndata: {},
      reportDataConfig: {},
      retid: [],
      levels: [],
      whatLA: [],
      whatL1: null,
      whatL2: null,
      level1: [],
      level2: [],
      levelId: 1,
      repDataDp: [],
      rowsdata: [],
      icons: [],
      iconsConfig: {},
      levelColumns: [],
      headerColumns: [],
      checkboxFlag: [],
      checkboxSelected: [],
      funCallParamArr: [],
      clickSymbolArr: [],
      sortKey: [],
      sortOrder: ['asc'],
      rowsDataDimKeys: [],
      levelKeys: ['level1_value', 'level2_value', 'level3_value', 'level4_value'],
      actionLevels: ['level1'],
      drilldownlevels: [],
      filterValue: '',
      cmnt: "",
      annotations: [],
      annotationTitle: "",
      picked: "",
      selected: {},
      assigned: "",
      section: [],
      userData: {},
      tagTitle: "",
      selectedRows: [],
      isAllSelected: false,
      dudepData: [],
      selectConfigVal: {},
      filter: {},
      filterPl: {},
      showTable: false,
      // config:[{"level1_value":"NIC","level2_value":"Expected","level3_value":"2023-02","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Excpected Conversion Month","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"Expected","level3_value":"2023-03","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Excpected Conversion Month","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"Expected","level3_value":"2023-04","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Excpected Conversion Month","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"Expected","level3_value":"2023-05","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Excpected Conversion Month","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Budget","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Residential/ Less Usage","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Customer not occupied","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Customer not available","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Site temporaray closed/ Vacated","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Not Interested","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Project dispute - Outstanding","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Project dispute - technical","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"On Call","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Rates","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"Enter Rate","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":"Number Input"},{"level1_value":"NIC","level2_value":"LOST","level3_value":"Lost to OEM","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Lost","level4_field_name":"Enter Name","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"radio","level4_input_type":"Char Input"},{"level1_value":"NIC","level2_value":"LOST","level3_value":"Lost to Local Party","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Lost","level4_field_name":"Enter Name","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"radio","level4_input_type":"Char Input"},{"level1_value":"AMC","level2_value":"Activated against Component No","level3_value":"Component No","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Component No","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"Char Input","level4_input_type":""},{"level1_value":"E Warranty","level2_value":"EWTY given by CAD","level3_value":"Date","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Pick a Date","level4_field_name":"","level1_input_type":"radio","level2_input_type":"radio","level3_input_type":"datepicker","level4_input_type":""},{"level1_value":"E Warranty","level2_value":"EWTY given by Dealer alone","level3_value":"Date","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Pick a Date","level4_field_name":"","level1_input_type":"radio","level2_input_type":"radio","level3_input_type":"datepicker","level4_input_type":""},{"level1_value":"Not Handed over","level2_value":"Not yet commissioned/ Handed over","level3_value":"Date","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Pick a Date","level4_field_name":"","level1_input_type":"radio","level2_input_type":"checkbox","level3_input_type":"datepicker","level4_input_type":""},{"level1_value":"Not Handed over","level2_value":"Turnkey contractor Not handed over to enduser/ warranty not over","level3_value":"Date","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Pick a Date","level4_field_name":"","level1_input_type":"radio","level2_input_type":"checkbox","level3_input_type":"datepicker"}],
      config: [],
      // This is much simpler if the select is it's own component.
      selectVal: {
        isActive: undefined,
        age: undefined,
        first_name: undefined,
        last_name: undefined
      },
      headerLvl2Display:"",
      headerLvl3Display:"",
      expandedL1: new Set(),  // store expanded rd1l1_name or rd1l1_id
      expandedL2: new Set(),  // store expanded rd1l2_name
      screenTitleInfo:'',
      headerHeight:0,
      hyperlinkConfig:'',
      tabReportConfig: null
    }
  },
  created: function () {
    //this.loadCustomer()
    this.tabReportConfig = this.parseTabReportConfig(this.viz1)
    this.loadReportlevel1(this.filters || {})
    this.listenToRouter();
    //this.loadConfig()
  },
  mounted() {
    this.headerHeightCal();
  },
  watch: {
    filteredItems(value) {
      // console.log("watch function",value.length,this.rowsdata.length)
      if (value.length < this.rowsdata.length && this.selectedRows.length > 0) {
        this.selectedRows = []
      }
    },
    selectedRows(value) {
      if (value.length === 0) {
        this.isAllSelected = false;
      }
    },
    viz1: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.tabReportConfig = this.parseTabReportConfig(newVal || {})
      }
    },
    filters: {
      immediate: false,
      deep: true,
      handler(newVal) {
        console.log("drilldown-report-page-tab props.filters:", newVal)
        this.filterPl = {...(newVal || {})}
        if (this.tabReportConfig) {
          this.loadReportlevel1(this.filterPl)
        }
      }
    },
    'selectConfigVal.level1_value'(newVal, oldVal) { //watch level1_value change in group action selection
      // console.log("watch fun select", newVal, oldVal)
      //If level1 selection is changed after selection of underlying levels then reset
      if (newVal !== oldVal && oldVal && Object.keys(this.selectConfigVal).length > 1) {
        this.selectConfigVal = {}
        this.actionLevels = ['level1']
        // this.selectConfigVal['level1_value']=newVal
      }
    },
  },

  computed: {
    gridContainerHeight() {
      const hasBanner = this.$store.state.bannerStatus;

      if (this.headerHeight > 70 && this.headerHeight <190) {
        return hasBanner ?"66.5vh" : "73vh" ;
      } if (this.headerHeight > 190){
        return hasBanner ?"61.5vh" : "67vh" ;
      } else {
        return hasBanner ? "72.5vh" : "79vh";
      }
    },
    "Rcolumns": function columns() {
      if (this.rowsdata.length == 0) {
        return [];
      }
      var intmdtColumns = Object.keys(this.rowsdata[0])
      var arr = intmdtColumns.filter(function (item) {
        return item !== "assign" && item !== "user_editable" //to avoid it in displaying in the table
      })
      console.log("arr",arr)
      return arr;
    },
    "R2columns": function columns() {
      if (this.firstDrilldownData.length == 0) {
        return [];
      }
      var intmdt2Columns = Object.keys(this.firstDrilldownData[0])
      var arr2 = intmdt2Columns.filter(function (item) {
        return item !== "assign"
      })
      // console.log("arr2",arr2);
      return arr2;
    },
    "R3columns": function columns() {
      if (this.secondDrilldownData.length == 0) {
        return [];
      }
      var intmdt3Columns = Object.keys(this.secondDrilldownData[0])
      var arr3 = intmdt3Columns.filter(function (item) {
        return item !== "assign"
      })
      return arr3;
    },

    "orderedData": function () {
      let result = this.rowsdata;
      if (this.filterValue) {
        result = result.filter(item => item.rd1.includes(this.filterValue));

      }

      return _.orderBy(result, item => {
        const value = item[this.sortKey];
        const isNumeric = !isNaN(value) && !isNaN(parseFloat(value));
        return isNumeric ? parseFloat(value) : value;
      }, this.sortOrder);

    },
    filteredItems() {
      // console.log("Rows Data Filtered", this.rowsdata)
      let result = this.rowsdata.filter(item => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.rowsDataDimKeys.forEach(key => {
          if (this.filter[key]) {
            keep =
                keep &&
                (this.filter[key].length == 0 ||
                    this.filter[key].includes(item[key]));
          }
        });

        return keep;
      });
      if (this.filterValue) {
        result = result.filter(obj =>
            Object.keys(obj)
                .some(key => (obj[key] != null) && obj[key].toString().toLowerCase().includes(this.filterValue.toLowerCase()))
        );

      }

      return _.orderBy(result, item => {
        const value = item[this.sortKey];
        const isNumeric = !isNaN(value) && !isNaN(parseFloat(value));
        return isNumeric ? parseFloat(value) : value;
      }, this.sortOrder);
    },
    filteredConfig() {
      // console.log("action Icons Config ", this.config)
      let result = this.config.filter(item => {
        let keep = true;
        // console.log("Selected Convig", this.selectConfigVal)

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.levelKeys.forEach(key => {
          if (this.selectConfigVal[key]) {
            keep =
                keep &&
                (this.selectConfigVal[key].length == 0 ||
                    this.selectConfigVal[key].includes(item[key]));
          }
        });

        return keep;
      });
      return result;
    },

    actionOptions() {
      // This could be simplified if the select was it's own component.
      const options = {};
      this.levelKeys.forEach(key => {
        let vals;
        if (key == 'level1_value') {
          vals = this.config.map(item => item[key]).filter(v => v);
        } else {
          vals = this.filteredConfig.map(item => item[key]).filter(v => v);
        }

        // console.log("Options Data Vals", vals);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals)).sort();
        // console.log("Distinct Options Data ", options[key]);
      });

      return options;
    },

    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      this.rowsDataDimKeys.forEach(key => {
        const vals = this.rowsdata.map(item => item[key]).filter(v => v);
        // console.log("Options Data Vals", vals);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals)).sort();
        // console.log("Distinct Options Data ", options[key]);
      });

      return options;
    },
    hasUserEditableKey() {
      return this.filteredItems.some(item => 'user_editable' in item);
    },
    selectableCount() {
      if (!this.hasUserEditableKey) return null;
      return this.filteredItems.filter(item => this.isRowEditable(item)).length;
    },
    isMultiFieldUpdate() {
      return !!(this.tabReportConfig && this.tabReportConfig.multiFieldUpdate === true)
    },
    levelActionMap() {
      const cfg = this.tabReportConfig || {}
      const apiCfg = this.drilldowndata && this.drilldowndata.actionIconsConfigByLevel
          ? this.drilldowndata.actionIconsConfigByLevel
          : {}
      const map = {}
      ;['level1', 'level2', 'level3', 'level4'].forEach((lvl) => {
        const levelApiCfg = apiCfg[lvl]
        const entry = cfg[lvl] && cfg[lvl][0] ? cfg[lvl][0] : null
        const actions = levelApiCfg && Array.isArray(levelApiCfg.actions)
            ? levelApiCfg.actions
            : (entry && entry.actionIconsConfig && Array.isArray(entry.actionIconsConfig.actions)
            ? entry.actionIconsConfig.actions
            : [])
        map[lvl] = actions.map((action) => {
          const normalized = {...action}
          if (!Array.isArray(normalized.tagList)) {
            normalized.tagList = this.extractTagListFromSql(normalized.input_list_sql)
          }
          normalized.value = normalized.value || ''
          return normalized
        })
      })
      return map
    }


  },

  methods: {
    getLevelActions(level) {
      return this.levelActionMap[level] || []
    },
    hasLevelActions(level) {
      return this.getLevelActions(level).length > 0
    },
    extractTagListFromSql(sqlText) {
      if (!sqlText || typeof sqlText !== 'string') return []
      const match = sqlText.match(/string_to_array\('([^']*)',\s*','\)/i)
      if (!match || !match[1]) return []
      return match[1]
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean)
          .map((tag) => ({tag_list: tag}))
    },
    getActionIconClass(action) {
      const name = (action && action.name ? action.name : '').toLowerCase()
      if (name.includes('comment')) return 'fa fa-comments text-primary'
      if (name.includes('assign')) return 'fa fa-user-cog text-info'
      if (name.includes('tag')) return 'fa fa-tags text-warning'
      if (action.action_type === 'textarea') return 'fa fa-comments text-primary'
      if (action.action_type === 'dropdown') return 'fa fa-caret-square-down text-info'
      if (action.action_type === 'radio' || action.action_type === 'checkbox') return 'fa fa-check-square text-warning'
      return 'fa fa-edit text-secondary'
    },
    getUniqueTagOptions(icon) {
      const rawList = icon && Array.isArray(icon.tagList) ? icon.tagList : []
      const values = rawList
          .map((item) => (item && item.tag_list != null ? String(item.tag_list).trim() : ''))
          .filter(Boolean)
      return Array.from(new Set(values))
    },
    openActionDialog(row, level, action) {
      const actionSet = this.getLevelActions(level)
      if (!actionSet.length) return
      const cloned = actionSet.map((item) => ({
        ...item,
        value: item.value || '',
        tagList: Array.isArray(item.tagList) ? item.tagList : []
      }))
      this.iconsConfig = cloned
      this.config = this.iconsConfig.filter(ic => ic.is_group_action == 'yes').length > 0
          ? (this.iconsConfig.filter(ic => ic.is_group_action == 'yes')[0].tagList || [])
          : []
      this.actionLevels = ['level1']
      this.selectConfigVal = {}
      const idKey = Object.keys(row || {}).find((k) => /dim\d+_id/i.test(k))
      const nameKey = Object.keys(row || {}).find((k) => /dim\d+_name/i.test(k))
      const rowIdentifier = row && (row[idKey] || row[nameKey] || row.rd1l1_name || row.rd1l2_name)
      this.section = rowIdentifier ? [rowIdentifier] : []
      this.tagHeader = action && action.name ? action.name : 'Action'
      this.tagTitle = `${this.tagHeader} -> ${level}`
      this.$refs["assign-box"].show()
    },
    getEffectiveFilters() {
      const fromProps = this.filters || {}
      const fromLocal = this.filterPl || {}
      return {...fromProps, ...fromLocal}
    },
    parseTabReportConfig(vizObj) {
      const raw = vizObj && vizObj.tab_report_json ? vizObj.tab_report_json : null
      if (!raw) return null
      try {
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
        const normalized = Array.isArray(parsed) ? (parsed[0] || null) : parsed
        if (!normalized) return null
        const vizSql = vizObj && typeof vizObj.datasql === 'string' ? vizObj.datasql.trim() : ''
        if (vizSql && normalized.level1 && normalized.level1[0]) {
          normalized.level1[0].datasql = vizSql
        }
        return normalized
      } catch (e) {
        console.error("error parsing tab_report_json", e)
        return null
      }
    },
    addRowAliases(rows, level) {
      if (!Array.isArray(rows) || !this.tabReportConfig || !this.tabReportConfig[level] || !this.tabReportConfig[level][0]) {
        return rows || []
      }
      const columnKeys = Object.keys(this.tabReportConfig[level][0].columns || {})
      const dimKeys = columnKeys.filter(k => k.startsWith('dim'))
      const idKey = dimKeys.find(k => k.toLowerCase().endsWith('_id')) || dimKeys[0]
      const nameKey = dimKeys.find(k => k.toLowerCase().endsWith('_name')) || dimKeys[0]
      rows.forEach((row) => {
        if (!row || typeof row !== 'object') return
        if (level === 'level1') {
          Object.defineProperty(row, 'rd1l1_id', { value: idKey ? row[idKey] : null, enumerable: false, configurable: true })
          Object.defineProperty(row, 'rd1l1_name', { value: nameKey ? row[nameKey] : null, enumerable: false, configurable: true })
        } else if (level === 'level2') {
          Object.defineProperty(row, 'rd1l2_name', { value: nameKey ? row[nameKey] : null, enumerable: false, configurable: true })
        }
      })
      return rows
    },
    toggleL1(rowd) {
      const key = rowd.rd1l1_id != null ? rowd.rd1l1_id : rowd.rd1l1_name;

      if (this.expandedL1.has(key)) {
        // collapse current row
        this.expandedL1.clear();
        this.firstDrilldownData = [];
        this.secondDrilldownData = [];
        this.whatLA = null;
        this.whatL1 = null;
        this.whatL2 = null;
      } else {
        // collapse others, expand only this
        this.expandedL1.clear();
        this.expandedL1.add(key);
        this.expandedL2.clear(); // reset children
        this.firstDrilldownData = [];
        this.secondDrilldownData = [];
        this.loadLevelData(...[[key]]);
      }
    },

    toggleL2(rowd, first) {
      const key = first.rd1l2_name;
      const val = [
        rowd.rd1l1_id != null ? rowd.rd1l1_id : rowd.rd1l1_name,
        first.rd1l2_name
      ];

      if (this.expandedL2.has(key)) {
        // collapse current child
        this.expandedL2.delete(key); // collapse
        this.secondDrilldownData = [];
        // this.whatLA = null;
        this.whatL2 = null;
      } else {
        // collapse others, expand only this
        this.expandedL2.clear();
        this.expandedL2.add(key);
        this.secondDrilldownData = [];
        this.loadLevelData(...[val]);
      }
      // console.log()
    },
    isExpandedL1(rowd) {
      const key = rowd.rd1l1_id != null ? rowd.rd1l1_id : rowd.rd1l1_name;
      return this.expandedL1.has(key);
    },
    isExpandedL2(first) {
      return this.expandedL2.has(first.rd1l2_name);
    },
    showTooltip() {
      const tooltip = this.$refs.tooltipIcon._tooltip;
      if (tooltip) {
        tooltip.show(); // Use the show method provided by Bootstrap-Vue
      }
    },
    hideTooltip() {
      const tooltip = this.$refs.tooltipIcon._tooltip;
      if (tooltip) {
        tooltip.hide(); // Use the hide method provided by Bootstrap-Vue
      }
    },
    resetActionOptions: function () {
      this.actionLevels = ['level1']
      this.selectConfigVal = {}
      this.iconsConfig = this.drilldowndata.iconsConfig || [{
        "name": "Comment",
        "action_type": "textarea",
        "input_key": "comment"
      }, {
        "name": "Tag",
        "action_type": "radio",
        "input_key": "tag_status",
        "tagList": [{"tag_list": "OnTrack"}, {"tag_list": " RedFlag"}, {"tag_list": " Validate"}]
      }]
    },
    appendCurLevel: async function (curLevel, input_type, e) {
      if (input_type == 'checkbox') {
        this.selectConfigVal[curLevel + '_value'] = this.selectConfigVal[curLevel + '_value'] || []
        if (e.target.checked) {
          this.selectConfigVal[curLevel + '_value'].push(e.target.value)
        } else {
          this.selectConfigVal[curLevel + '_value'].pop(e.target.value)
        }

      }


      // let key = curLevel+'_value'
      let levelNo = curLevel.replace('level', '') - 1
      let levelPlus = levelNo + 2
      //Push curLevel + 1 only if new level is added
      if (!this.actionLevels.includes('level' + levelPlus)) {
        this.actionLevels.push('level' + levelPlus)
      }

      let levelKeys = this.levelKeys.slice(0, levelNo)
      // console.log("Current Level is ", curLevel, levelNo, levelKeys)
      let result = this.config.filter(item => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        levelKeys.forEach(key => {
          if (this.selectConfigVal[key]) {
            keep =
                keep &&
                (this.selectConfigVal[key].length == 0 ||
                    this.selectConfigVal[key].includes(item[key]));
          }
        });

        return keep;
      });


      let vals = result.map(item => item[curLevel + '_value']).filter(v => v)
      let curLevelOptions = Array.from(new Set(vals)).sort();
      this.actionOptions[curLevel + '_value'] = curLevelOptions
      // console.log("current Level Appending distinct values", result, curLevelOptions, this.actionOptions)
      /*
            this.actionOptions = this.makeListBoxOptions()
                console.log("Current Level ",this.actionOptions,curLevel)
      */

    },
    submit() {
      this.showTable = true;
    },

    sortBy: function (key) {
      // console.log("The sort Key is ", key)
      if (key == this.sortKey) {
        this.sortOrder = (this.sortOrder == 'asc') ? 'desc' : 'asc';
        this.sortKey = key;
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    },
    getClass(a) {
      const level = String(a || '').trim().toLowerCase()
      if (level === 'level3') {
        //this.class="first"
        return 'third'
      }
      if (level === 'level2') {
        //this.class = "second"
        return 'second'
      }
      if (level === 'level1') {
        //this.class = "third"
        return 'first'
      }
    },
    getRowColorValue(row, level) {
      if (!row || !this.tabReportConfig || !this.tabReportConfig[level] || !this.tabReportConfig[level][0]) {
        return row && row.rd6 ? row.rd6 : ''
      }
      const levelColumns = this.tabReportConfig[level][0].columns || {}
      const colorHeader = levelColumns.color_dim
      if (!colorHeader) {
        return row.rd6 || row.color_dim || ''
      }
      // Prefer direct config key mapping (safe even when visible headers differ from rendered data columns).
      const explicitColorKey = Object.keys(levelColumns).find((k) => k.toLowerCase() === 'color_dim')
      if (explicitColorKey && row[explicitColorKey] != null) {
        return row[explicitColorKey]
      }
      // Fallback: find the data key whose configured header matches color_dim display name.
      const mappedColorKey = Object.keys(levelColumns).find((k) => levelColumns[k] === colorHeader)
      if (mappedColorKey && row[mappedColorKey] != null) {
        return row[mappedColorKey]
      }
      return row.color_dim || row.rd6 || ''
    },
    selectAll() {
      this.selectedRows = [];

      if (!this.isAllSelected) {
        this.filteredItems.forEach(row => {
          if (this.isRowEditable(row)) { // allow only editable records
            this.selectedRows.push(row.rd1l1_name);
          }
        });
      }
      this.isAllSelected = !this.isAllSelected;
    },
    isRowEditable(row) {
      if (!row || !Object.prototype.hasOwnProperty.call(row, 'user_editable')) return true
      const value = row.user_editable
      if (typeof value === 'boolean') return value
      if (typeof value === 'number') return value !== 0
      const normalized = String(value).trim().toLowerCase()
      if (['false', 'f', '0', 'no', 'n'].includes(normalized)) return false
      if (['true', 't', '1', 'yes', 'y'].includes(normalized)) return true
      return Boolean(value)
    },
    /* downloadFile: function (file_name) {
             console.log(file_name, 'is the name')
       axios.get(`/api/file_exists_processed?fileName=${file_name}`)
           .then(function (resp) {
             if (resp.data.exists) {
               console.log(file_name, 'is the name2')

               return `http://localhost:9888/${file_name}`
              // return `http://139.59.58.160:9888/${file_name}`
             } else {
              alert("File does not Exists")
             }
           }, function () {
             alert('Error in checking file present status');
           })
       },*/
    handleActionIconFunctionCall(fnName, index, x) {
      let val = !this.iconOnChangeFlag[index]
      this.$set(this.iconOnChangeFlag, index, val) //Array mutation happens only by set function or other mutation methods like slice,push,pop etc
      // console.log("Handle function called with func name", fnName, this.iconOnChangeFlag, x)
      this[fnName](x)
    },
    downloadFile: function (fileId) {
      let file = this.rowsdata.filter(item => item.rd1l1_name == fileId)
      var fileName = this.rowsdata.filter(item => item.rd1l1_name == fileId)[0].rd1l3_name
      if (file[0].rd1l6_name == 'success') {
        fileName = 'processed/' + fileName
      } else if (file[0].rd1l6_name == 'error') {
        fileName = 'error_file/' + fileName
      } else if (file[0].rd1l6_name == 'Unprocessed') {
        fileName = 'landing/' + fileName
      }
      // console.log(fileName, 'is the file name of ', fileId, file, fileName)
      // window.location= `http://localhost:9888/${fileName}`
      window.location = `http://139.59.58.160:9888/${fileName}`
    },

    loadDudep: function () {
      console.warn("Disabled API call: /api/dedup-get")
    },
    //Put/Update Request
    accept: function (x) {
      this.$refs["accept-box"].show();
      if (x) this.loadReportlevel1(this.filterPl)
      console.warn("Disabled API call: /api/dedup-update/*/Accept")
    },
    reject: function (x) {
      this.$refs["reject-box"].show();
      if (x) this.loadReportlevel1(this.filterPl)
      console.warn("Disabled API call: /api/dedup-update/*/Reject")
    },
    assignBox: function (id) {
      let what = (this.reportDataConfig && Array.isArray(this.reportDataConfig.columns) && this.reportDataConfig.columns.length > 0)
          ? this.reportDataConfig.columns[0]
          : {}
      const menuParam = this.$route.params.submenuId
      const menuDetails = (this.$store.state.menuMasterFlat || []).filter(m => m.menuId === menuParam)
      const safeMenuName = what.menuName || menuDetails[0]?.menuName || menuParam || 'tab-report'
      // console.log(
      //     `ENTERED into the assignBox function(${id},${what.menuName}, ${what.reportName})`
      // );
      this.cmt = "";
      this.pg = safeMenuName;
      this.section = id;
      this.tagHeader = "User Assignment";
      this.tagTitle =
          this.tagHeader + "->" + this.pg + "->" + (this.section.length > 3 ? this.section.length + ' rows selected' : this.section);
      if (this.section.length > 0 && this.section.length < 500) this.$refs["assign-box"].show();
      else this.$refs["error-box"].show()
      this.assigned = this.$store.state.firstName //default to self
      // axios.get("/api/user").then(res => {
      //       this.userData = res.data
      //     },
      //     err => {
      //       console.log('Error Fetching data', err)
      //     })
    },
    postAssign: async function () {
      this.spinner = true
      const url = "/api/businessActions";
      try {
        let selected = []
        this.iconsConfig.tagList && this.iconsConfig.tagList.filter(f => {
          if (f.value) {
            selected.push(f.tag_list)
            return f.tag_list;
          }
        })
        let tagStatus = this.selected.length > 0 ? this.selected.toString() : selected.length > 0 ? selected.toString() : ''

        let actionValues = {}
        this.iconsConfig.forEach(ic => {
          if (ic.action_type === 'checkbox') {
            let selectedValues = []
            ;(ic.tagList || []).filter(f => {
              if (f.value) selectedValues.push(f.tag_list)
            })
            actionValues[ic.input_key] = selectedValues.toString()
          } else if (ic.is_group_action != 'yes') {
            actionValues[ic.input_key] = ic.value ? ic.value.toString() : ''
          }
        })

        let popLastItem = _.clone(this.selectConfigVal)
        let keys = Object.keys(this.selectConfigVal)
        if (keys.length > 0) {
          delete popLastItem[keys[keys.length - 1]]
        }

        let filteredConfig = this.config.filter(item => {
          let keep = true;
          this.levelKeys.forEach(key => {
            if (popLastItem[key]) {
              keep =
                  keep &&
                  (this.selectConfigVal[key].length == 0 ||
                      this.selectConfigVal[key].includes(item[key]));
            }
          });
          return keep;
        });

        let groupConfigVal = {}
        Object.keys(this.selectConfigVal).forEach(lk => {
          let key = lk.replace('_value', '')
          let singleConfig = filteredConfig[0]
          if (!singleConfig) return
          let inputFieldName = singleConfig[key + '_field_name']
          if (inputFieldName) {
            groupConfigVal[inputFieldName] = this.selectConfigVal[key + '_value'].toString()
          }
        })

        let mergedActionValues = {...actionValues, ...groupConfigVal}
        const sectionAsArray = Array.isArray(this.section) ? this.section : [this.section].filter(Boolean)
        this.assigned = this.assigned || mergedActionValues.assign || this.$store.state.firstName || ''
        const menuParam = this.$route.params.submenuId
        const menuDetails = (this.$store.state.menuMasterFlat || []).filter(m => m.menuId === menuParam)
        const safeMenuName = this.pg || menuDetails[0]?.menuName || menuParam || 'tab-report'
        const data = {
          userId: 1,
          userName: "Admin",
          menuName: safeMenuName,
          menuId: menuParam,
          screenletName: this.viz1.screenletTitleDpName,
          vizletName: this.viz1.vizletTitleDpName,
          recordIdentification: sectionAsArray,
          annotation: this.cmnt,
          tagStatus: this.picked || tagStatus,
          assignedTo: this.assigned,
          bizInputValues: mergedActionValues
        };

        const controller = apiAbort.new()
        await axios.post(url, data, {signal: controller.signal})
        await this.$store.dispatch("loadAnnotations")
        await this.loadReportlevel1(this.filterPl)
      } catch (e) {
        console.error("error posting business actions", e)
      } finally {
        this.spinner = false
        this.selectedRows = []
        this.selectConfigVal = {}
      }
    },
    tagBox: function (id) {
      let what = this.reportDataConfig.columns[0]
      // console.log(
      //     `ENTERED into the tagBox function(${id},${what.menuName}, ${what.reportName})`
      // );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = id;
      this.tagHeader = "User Tagging";
      this.tagTitle =
          this.tagHeader + "->" + this.pg + "->" + this.section;
      this.$refs["tag-box"].show();
    },
    postTagging: function () {
      this.loadReportlevel1(this.filterPl)
      console.warn("Disabled API call: /api/businessActions")
    },
    commentBox: function (id) {
      let what = this.reportDataConfig.columns[0]
      // console.log(
      //     `ENTERED into the commentBox function(${id},${what.menuName}, ${what.reportName})`
      // );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = id;
      this.annotationHeader = "User Annotations";
      this.annotationTitle =
          this.annotationHeader + "->" + this.pg + "->" + this.section;
      this.$refs["comment-box"].show();
    },
    postAnnotation: function () {
      this.loadReportlevel1(this.filterPl)
      console.warn("Disabled API call: /api/businessActions")
    },

    loadLevelData: function (l1A) {

      var l1 = l1A[0]
      var l2 = l1A[1]
      // console.log('Level 1 Data', l1A)
      // var array1 = [...Array(5)]
      // console.log("Array", Object.getOwnPropertyNames(array1))
      // console.log("this.whatLA",_.isEqual(this.whatLA, l1A),this.whatLA)
      // if (_.isEqual(this.whatLA, l1A)) {
      //   this.whatLA = null
      //   this.whatL1 = null
      //   this.whatL2 = null
      // } else {
        this.whatLA = [...l1A]
        this.whatL1 = l1
        this.whatL2 = l2
        var arrayleng = l1A.length
        const requestedLevel = 'level' + (arrayleng + 1)
        const requestData = {
          level: requestedLevel,
          tabReportJson: this.tabReportConfig,
          drilldownParams: l1A,
          filterPl: this.getEffectiveFilters()
        };
        console.log("tabReportDrilldown requestData.filterPl:", requestData.filterPl)
        const controller = apiAbort.new()
        axios.post('/api/tabReportDrilldown', requestData,{
          signal:controller.signal,
          headers: {
            'info-params': JSON.stringify({
              menuId: this.$route.params.menuId,
              submenuId: this.$route.params.submenuId
            }),
            'Content-Type': 'application/json'
          }
        })
            .then(res => {
              const levelRows = this.addRowAliases(res.data.rowsData || [], requestedLevel)
              if (arrayleng == 1) {
                this.firstDrilldownData = levelRows
              } else if (arrayleng == 2) {
                this.secondDrilldownData = levelRows
              }
            }).catch(e=>{
                console.log("error",e);
            })
        // console.log("Outside if cond POst API", this.firstDrilldownData)
        // console.log("Outside if cond POst API", this.secondDrilldownData)

      // }

    },

    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from, to) {
        apiAbort.cancel()
        console.log(`router moved to ${from.path} from ${to.path}`)
        //console.log(`router moved to ${from.path} from ${to.path}, page viz = ${$this.rows.length}`)
        $this.rowsdata = []
        $this.headerColumns = []
        $this.section = ''
        $this.dimSelectDpValues = []
        $this.dimSelectDpValuesPl = [],
            $this.dimInputDpValuesPl = [],
            $this.filter = {}
        $this.filterPl = {}
        $this.listBoxOptions = []
        $this.listBoxOptionsPl = []
        $this.showTable = false
        setTimeout(() => {
          if (from.matched.some(record => record.meta.requiresDrilldownConfig)) {
            $this.loadReportlevel1($this.filters || {})
          }
        }, 300)

      })
    },

    headerHeightCal() {
      const headerEl = this.$el.querySelector(".card-body-header");
      if (headerEl) {
        // Create observer
        this.headerObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
            this.headerHeight = entry.contentRect.height;
            // console.log("Card header height:", this.headerHeight);
          }
        });
        this.headerObserver.observe(headerEl);
      }
    },
    loadReportlevel1: async function (filterParam) {
      let menuParam = this.$route.params.submenuId
      let submenuParam = this.$route.params.submenuId
      // console.log('ddrn2', 'loading state', filterParam);
      this.$store.dispatch("loadState").then(() => {

        let actionIconsData = this.$store.state.actionIcons
        // console.log("actions:", actionIconsData)

        this.submenuParam1 = submenuParam
        this.funCallParamArr = ['True', Array('True', 'rowd.rd1l1_id'), Array('True', 'rowd.rd1l1_id', 'rowd.rd1l2_name')]
        this.clickSymbolArr = ['+', '&gt;&gt;', '&#8680;']

        //Get Listbox Data if null derive from report data

        /*let filterParam = {}
        if(Object.entries(this.filterPl).length>0){
          filterParam = this.filterPl
        }*/
        if (filterParam == undefined) {
          filterParam = {}
        }
        // console.log("Report Called with Param", filterParam)
        const controller = apiAbort.new();

        if (!this.tabReportConfig) {
          console.error("tab_report_json is missing or invalid")
          return
        }

        const payload = {
          level: 'level1',
          tabReportJson: this.tabReportConfig,
          drilldownParams: [],
          filterPl: {...this.getEffectiveFilters(), ...(filterParam || {})}
        }
        console.log("tabReportDrilldown payload.filterPl:", payload.filterPl)

        axios.post('/api/tabReportDrilldown', payload, {
          signal : controller.signal,
          headers: {
            'info-params': JSON.stringify({
              menuId: this.$route.params.menuId,
              submenuId: this.$route.params.submenuId
            }),
            'Content-Type': 'application/json'
          }
        })
            //      axios.get('/api/reportConfigColumn/'+ menuParam + '/' +submenuParam)
            .then(async res => {
              this.drilldowndata = res.data
              this.reportDataConfig = this.drilldowndata
              // console.log("REport PAge DATA config", this.reportDataConfig)
              this.repTitle = (this.viz1 && (this.viz1.vizletTitleDpName || this.viz1.viztypeName)) || "Drilldown Report"
              this.screenTitleInfo = this.drilldowndata.screenTitleInfo || this.screenTitleInfo
              // console.log("data check:",this.drilldowndata)
              this.columns = this.drilldowndata.columns || []
              this.rowsdata = this.addRowAliases(this.drilldowndata.rowsData || [], 'level1')
              this.showTable = true
              this.icons = this.drilldowndata.icons || []


              // let dbIconsConfig={"actions":[{"name":"Obligation","level":1,"is_group_action":"yes","action_type":"radio","input_key":"obligation","group_input_list_sql":"select unnest(string_to_array('OnTrack,RedFlag,Validate',',')) as tag_list","group_action":[{"name":"Status","level":2,"action_type":"checkbox","input_key":"status","input_list_sql":"select unnest(string_to_array('WTY,Active,Not Active',',')) as tag_list"},{"name":"Extended warranty","level":3,"action_type":"datepicker","input_key":"date for extended warranty"},{"name":"Expected conversion month","action_type":"dropdown","level":4,"input_key":"expected conversion month","input_list_sql":"select unnest(string_to_array('202312,202401,202403',',')) as tag_list"}]},{"name":"Comment","action_type":"textarea","input_key":"comment"},{"name":"Assign","action_type":"dropdown","input_key":"assign","input_list_sql":"fw_core_config_conn select user_short_name as tag_list from fw_core.fw_m_user where client_id=10 and function_id=1"},{"name":"Additional","action_type":"text"}]}
              const level1Actions = (this.drilldowndata.actionIconsConfigByLevel &&
                  this.drilldowndata.actionIconsConfigByLevel.level1 &&
                  Array.isArray(this.drilldowndata.actionIconsConfigByLevel.level1.actions))
                  ? this.drilldowndata.actionIconsConfigByLevel.level1.actions
                  : null
              this.iconsConfig = level1Actions || this.drilldowndata.iconsConfig || [{
                "name": "Comment",
                "action_type": "textarea",
                "input_key": "comment"
              }, {
                "name": "Tag",
                "action_type": "radio",
                "input_key": "tag_status",
                "tagList": [{"tag_list": "OnTrack"}, {"tag_list": " RedFlag"}, {"tag_list": " Validate"}]
              }]
              // this.iconsConfig=dbIconsConfig.actions
              this.config = this.iconsConfig.filter(ic => ic.is_group_action == 'yes').length > 0 ? this.iconsConfig.filter(ic => ic.is_group_action == 'yes')[0].tagList : []

              this.iconsConfig["tagList"] = this.drilldowndata.tagList || [{"tag_list": "OnTrack"}, {"tag_list": " RedFlag"}, {"tag_list": " Validate"}]
              this.cleanedDownload = this.drilldowndata.rowsData || []
              this.momentAll = `${moment().format('YYYY-MM-DD hh:mm')}_${this.repTitle}.csv`
              // console.log("API Response", this.config, this.drilldowndata, this.icons, this.iconsConfig, this.iconsConfig['tagList'].map(k => k['tag_list']))
              this.drilldownlevels = this.drilldowndata.levels || [...new Set(this.columns.map(dl => dl.drilldownLevel))]
              this.levels = 1

              //Rep level action icons
              let repIcons = this.icons.filter(indi => indi.drilldownLevel == 'level1') // get only level1 for report level icons
              // console.log('Rep Icons:', this.repIcons)
              var repActionIconsSyspkArray = repIcons[0] && repIcons[0].repActionIconsSyspkArray ? repIcons[0].repActionIconsSyspkArray : []
              // console.log('Rep Action icons', repActionIconsSyspkArray, repIcons[0].repActionIconsSyspkArray)
              this.currentRepActionIconsData = actionIconsData.filter(r => repActionIconsSyspkArray.includes(r.syspk))
              // console.log('Rep Action icons:', repActionIconsSyspkArray)

              for (var i = 1; i <= this.drilldownlevels.length; i++) {
                var value = 'level' + i
                this.levelColumns[i] = this.columns.filter(ind =>
                    ind.drilldownLevel == value &&
                    String(ind.headerColumnDisplay || '').toLowerCase() !== 'checkbox'
                )
                this.checkboxFlag[i] = this.columns.filter(ind =>
                    ind.drilldownLevel == value &&
                    String(ind.headerColumnDisplay || '').toLowerCase() === 'checkbox'
                ).length > 0 ? true : false
                this.headerColumns[i] = this.levelColumns[i].map(function (el) {
                  return el.headerColumnDisplay;
                })
                this.levelicons[i] = this.icons.filter(indi => indi.drilldownLevel == value)
                if (i === 1 && this.isMultiFieldUpdate) {
                  this.checkboxFlag[i] = true
                }

                // console.log('WC1:', this.icons, this.columns)

                var vizletActionIconsSyspkArray = this.levelicons[i][0] && this.levelicons[i][0].actionIconsSyspkArray ? this.levelicons[i][0].actionIconsSyspkArray : []
                // console.log('WC2:', vizletActionIconsSyspkArray, this.levelicons[i][0].actionIconsSyspkArray)

                this.currentMenuActionIconsData[i] = actionIconsData.filter(r => vizletActionIconsSyspkArray.includes(r.syspk))
                //   console.log('WC:',vizletActionIconsSyspkArray,this.currentMenuActionIconsData,this.drilldowndata.icons)

                this.currentMenuActionIconsData[i].sort(sortFuncAI); //sorting the currentMenuActionIconsData
                // console.log("actions1:", this.currentMenuActionIconsData[i], actionIconsData)
                this.iconOnChangeFlag[i] = Array(this.currentMenuActionIconsData[i].length).fill(true);


              }

              function sortFuncAI(a, b) {
                //    console.log("test sort ", a,b)
                return vizletActionIconsSyspkArray.indexOf(a.syspk) - vizletActionIconsSyspkArray.indexOf(b.syspk);
              }

              //this.headerColumnsDisplay = this.apiData.columns.map(function (el) { return el.headerColumnDisplay; })
              // console.log("Drilldown data level1", this.headerColumns[1])
              // console.log("Drilldown data level2", this.headerColumns[2])
              // console.log("Drilldown data level3", this.headerColumns[3])
              // console.log("Function Call PAram ", this.funCallParamArr)
              // console.log("Clickable Symbol", this.clickSymbolArr)
              var rowsDataKeys = Object.keys(this.rowsdata[0])

              function createObject(keys, values) {
                const obj = Object.fromEntries(
                    keys.map((key, index) => [key, values[index]]),
                );

                return obj;
              }

              this.rowsDataDimKeys = rowsDataKeys.filter(dim => dim.includes('d'))
              this.dimSelectDpValues = this.headerColumns[1].slice(0, this.rowsDataDimKeys.length)
              let dimSelectObj = createObject(this.headerColumns[1], rowsDataKeys)
              let dimRowsData = this.rowsdata.map(rd => _.pick(rd, this.rowsDataDimKeys))


// we pass a comparator function that compares objects a & b
              this.uniqueDimObj = _.uniqWith(dimRowsData, (a, b) => {
                // we use _.isEqual to compare if a & b have exactly the same values for all the properties
                return _.isEqual(a, b)
              });

              this.dimSelectDpValues = []
              Object.entries(dimSelectObj).filter(([key, value]) => {
                if (this.rowsDataDimKeys.includes(value)) {
                  // console.log("dimension key and value", key, value)
                  this.dimSelectDpValues.push(key)
                }
              })
              // console.log('Dimension variables Keys', dimSelectObj, this.rowsDataDimKeys)
              // console.log('Dimension variables Keys', this.dimSelectDpValues, dimRowsData, this.uniqueDimObj)

              this.level1Columns = this.headerColumns[1]
              this.level2Columns = this.headerColumns[2]
              this.level3Columns = this.headerColumns[3]

              const removeEmptyOrNull = (obj) => {
                Object.keys(obj).forEach(k =>
                    (obj[k] && typeof obj[k] === 'object') && removeEmptyOrNull(obj[k]) ||
                    (!obj[k] && obj[k] !== undefined) && delete obj[k]
                );
                return obj;
              };

              this.uniqueDimObj = removeEmptyOrNull(this.uniqueDimObj) //removes the null and empty values in the resultset
              //convert set of values into an array using array.from
              //this.optionValues[index] = Array.from(new Set(resData.map(c => c.dim1).filter(x => x != null)))
              //return temp
              this.filter = Object.fromEntries(
                  Object.keys(this.uniqueDimObj[0]).map(k => {
                    return [k, []]
                  })
              )
              this.listBoxOptions = {}
              // let currentMenu = this.$store.state.menuMasterFlat.filter(f => f.menuId === menuParam)
              // console.log("Audit log", menuParam, this.$route.params.menuId, currentMenu[0])
              // this.$commonFn.auditLog(9999,menuParam, menuParam, "Drilldown-report", "POST", );
              // menusyspk, menuid, menuname, vizunit, action, response

            }).catch(e=>{
              console.error("error",e);
            })
        const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam)
        // console.log("menuDetails", menuDetails);
        this.$commonFn.auditLog(menuDetails[0]?.syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName, "GET", "Success",this.$store.state.deviceType)
      })
    }
  }
}

</script>
<style>
.first {
  background-color: #fff7e6 !important;
  border-left: 3px solid #ffa500;
}

.second {
  background-color: #fff1f0 !important;
  border-left: 3px solid #8b0000;
}

.third {
  background-color: #fff5f5 !important;
  border-left: 3px solid #ee4b2b;
}

.grid-container {
  overflow: auto;
}


.grid-col--fixed-left {
  position: sticky;
  left: 0;
  /*z-index: 9998;*/
  background: white;

  outline: 2px solid #e4e7ea;
}

.grid-item--header-one {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
}

.blue-placeholder::placeholder {
  color: #A1CCFF;
  opacity: 1; /* Firefox reduces opacity by default */
}

.custom-icon {
  background-color: black;
  color: white;
  border-radius: 50%;
  border: 1px solid black
}

.my-custom-tooltip {
  background-color: transparent !important; /* Semi-transparent background */
  padding: 15px !important; /* Increased padding for better spacing */
  border: none !important;
  box-shadow: none !important; /* Subtle shadow for depth */
}

.my-custom-tooltip .tooltip-inner {
  border: 1px solid black;
  background-color: white;
  color: black;
  max-width: 1200px; /* Set max width */
  max-height: 300px; /* Set max height to enable scrolling */
  overflow-y: auto; /* Enable vertical scrollbar */
  pointer-events: auto; /* Allow interaction with tooltip content */
  font-size: 16px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

/* Prevent hiding the tooltip when hovering into the content */
.my-custom-tooltip:hover {
  display: block !important; /* Ensure the tooltip stays visible */
}

dialog {
  width: 66vw;
  height: 66vh;
  margin: auto;
  border: 0 none;
  border-radius: 10px;
  padding: 2em;
}

dialog::backdrop {
  background-color: rgba(0, 0, 0, 20%);
}

.row {
  margin: 0px 2px;
}

.card-section {
  width: 100%
}

.banner-true {
  height: 86vh;
}

.banner-false {
  height: 93vh;
}

.card-body {
  padding: 1px;
}

.disabled-checkbox {
  background-color: #f2dede; /* light red */
  cursor: not-allowed;
  border-radius: 4px;
}

.action-icon-btn {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  min-height: 26px;
  border-radius: 6px;
  transition: background-color 0.15s ease-in-out;
}

.action-icon-btn:hover {
  background-color: #eef7ff;
}

</style>